import React from 'react';

export interface DataOneLinerType {
  label: string;
  value: number | string;
}

const DataOneLiner = ({ label, value }: DataOneLinerType): JSX.Element => {
  return (
    <div className="mb-2">
      <span className="f-mono f-small f-bold">{label}</span>
      <span className="f-mono f-small"> · {value}</span>
    </div>
  );
};

export default DataOneLiner;
